(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('.tdw-product-gallery').forEach((gallery) => {
      if (gallery.dataset.tdwGalleryReady) return;
      gallery.dataset.tdwGalleryReady = 'true';
      const scroller = gallery.querySelector('.product__thumbs--scroller');
      if (!scroller) return;
      let previousActive = null;
      const syncSelection = () => {
        const links = scroller.querySelectorAll('[data-product-thumb]');
        links.forEach((link) => {
          if (link.classList.contains('is-active')) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        if (!window.matchMedia('(max-width: 768px)').matches) return;
        const active = scroller.querySelector('.product__thumb-item:not(.hide) .is-active');
        if (!active || active === previousActive) return;
        previousActive = active;
        const item = active.closest('.product__thumb-item');
        const itemRect = item.getBoundingClientRect();
        const viewRect = scroller.getBoundingClientRect();
        if (itemRect.left < viewRect.left) scroller.scrollLeft += itemRect.left - viewRect.left - 2;
        else if (itemRect.right > viewRect.right) scroller.scrollLeft += itemRect.right - viewRect.right + 2;
      };
      const observer = new MutationObserver(syncSelection);
      observer.observe(scroller, { subtree: true, attributes: true, attributeFilter: ['class'] });
      syncSelection();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
